import {
    Box, Button, Checkbox, Flex, Grid, GridItem, IconButton, Image, Input, InputGroup, Link, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, Table, Tbody, Td, Text, Textarea, Th, Thead, Tooltip, Tr,
    useDisclosure,
} from "@chakra-ui/react";
import { AddIcon, CheckIcon, CloseIcon, HamburgerIcon, TimeIcon, ViewIcon } from "@chakra-ui/icons";
import { getStatusStyle, ILead, ILeadTable } from "../../LeadPool/model";
import { AlertCard, CustomTable, CustomToast } from "../../../../components";
import LeadRequirementForm from "../LeadRequirementForm/leadRequirementForm";
import ArrowIcon from "../../../../assets/Images/Arrow-icon.svg"
import ViewIconn from "../../../../assets/Images/view-icon.svg"
import HistoryIcon from "../../../../assets/Images/history-icon.svg"
import EditIcon from "../../../../assets/Images/edit-icon.svg"
import UserIcon from "../../../../assets/Images/user-icon.svg";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import LeadRequirement from "../../LeadRequirement";
import { showDateTime } from "../../../../utilities/helper";
import { useAuth } from "../../../../hooks/useAuth";
import CustomExpandTable from "../../../../components/CustomExpandTable";
import { Column } from "../../../../components/CustomExpandTable/customExpandTable";
import { applyMask } from "../../../../utilities/masking";
import MeetingFormTab from "../MeetingFormTab";
import FollowUpFormTab from "../FollowUpFormTab";
import SendMessageForm from "../SendMessageForm";
import MeetingIcon from "../../../../assets/Images/meeting-icon.svg"
import FollowupIcon from "../../../../assets/Images/followup-small-icon.svg"
import SendMessageIcon from "../../../../assets/Images/send-msg-icon.svg"
import * as routesNames from '../../../../constant/routes'
import MyDiv from "./createdLeadList.style";
import EditIconn from "../../../../assets/Images/edit-icon.svg"
import { a } from "framer-motion/dist/types.d-BJcRxCew";
import { useFetch } from "../../../../hooks/useFetch";

interface Props {
    leadData: ILeadTable;
    loading: boolean;
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    toggleReveal: (rowIndex: number, field: string) => void;
    maskText: (text?: string) => string;
    handleEditLead: (row: ILead) => void;
    handleViewLead: (lead: ILead) => void;
    handleHistoryLead: (lead: ILead) => void;
    handleOpenStatusModal: (row: ILead) => void;
    expandedLeadId: number | null;
    toggleRequirementRow: (lead: ILead) => void;
    maskingSettings: any;
    revealedField: {
        rowIndex: number | null;
        field: string | null;
    };
    loadMyLeads: () => Promise<void>;
    revealedRow: number | null;
    canViewAllContacts: boolean;
    canViewOnlyContacts: boolean;
    canViewRowContacts: boolean;
    canHideContacts: boolean;
    onMeetingRefresh: (leadId: number) => void;
    onFollowUpRefresh: (leadId: number) => void;
    onMessageRefresh: () => Promise<void>;

}

const CreatedLeadList = ({ leadData, loading, search, setSearch, toggleReveal, maskText, handleEditLead, handleViewLead, handleHistoryLead, handleOpenStatusModal, onMeetingRefresh, onFollowUpRefresh, onMessageRefresh,
    expandedLeadId, toggleRequirementRow, maskingSettings, revealedField, revealedRow, canViewAllContacts, canViewOnlyContacts, canViewRowContacts, canHideContacts, loadMyLeads }: Props) => {
    const navigate = useNavigate();
    const [expandType, setExpandType] = React.useState<{ leadId: number; type: "requirement" | "meeting" | "followup" | "message"; } | null>(null);
    const { loginObj } = useAuth();
    const { userName, hasPermission } = useAuth();
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const canViewHistory = hasPermission("CreatedLead", "History");
    const canViewMeetings = hasPermission("CreatedLead", "Meeting");
    const canViewFollowUps = hasPermission("CreatedLead", "Followup");
    const canViewMessages = hasPermission("CreatedLead", "Send Message");
    const canUpdateStatus = hasPermission("CreatedLead", "UpdateStatus");
    const canViewLeadAcceptanceHistory = hasPermission("CreatedLead", "LeadAcceptanceHistory");
    const canViewLeadDetail = hasPermission("CreatedLead", "ViewLeadDetail");
    const canEdit = hasPermission("CreatedLead", "leadEdit");
    const canNavigateLeadDetail = hasPermission("CreatedLead", "NavigateLeadDetail");
    const [approvalLoading, setApprovalLoading] = useState(false);
    const canAcceptLead = hasPermission("CreatedLead", "AcceptLead");
    const canRejectLead = hasPermission("CreatedLead", "RejectLead");
    const [approvalType, setApprovalType] = useState<"accept" | "reject" | null>(null);
    const [selectedLead, setSelectedLead] = useState<ILead | null>(null);
    const [rejectReason, setRejectReason] = useState("");
    const canViewNotesAndResponse = hasPermission("CreatedLead", "ViewNotesAndResponse");
    const [selectedLeads, setSelectedLeads] = useState<number[]>([]);
    const [selectAllLeads, setSelectAllLeads] = useState(false);
    const [bulkApprovalLoading, setBulkApprovalLoading] = useState(false);
    const [bulkApprovalType, setBulkApprovalType] = useState<"accept" | "reject" | null>(null);
    const [bulkReason, setBulkReason] = useState("");

    const {
        isOpen: isBulkApprovalOpen,
        onOpen: onBulkApprovalOpen,
        onClose: onBulkApprovalClose,
    } = useDisclosure();


    const { isOpen: isApprovalOpen, onOpen: onApprovalOpen, onClose: onApprovalClose, } = useDisclosure();
    const { isOpen: isNotesModalOpen, onOpen: onNotesModalOpen, onClose: onNotesModalClose } = useDisclosure();
    const [selectedNotesResponse, setSelectedNotesResponse] = useState<string>("");
    const RevealField = ({
        rowIndex,
        field,
        value,
        isExpanded = false,
        className,
        children,
    }: {
        rowIndex: number;
        field: string;
        value?: string;
        isExpanded?: boolean;
        className?: string;
        children?: React.ReactNode;
    }) => {
        const roleId = loginObj?.roleId?.[0];
        const isSingleFieldRevealed = revealedField.rowIndex === rowIndex && revealedField.field === field;
        const isRowRevealed = revealedRow === rowIndex;
        const shouldShowValue = canViewAllContacts || isSingleFieldRevealed || isRowRevealed;
        const maskType = maskingSettings[field] || "Hidden";
        return (
            <Box position="relative">

                <Box
                    userSelect={shouldShowValue ? "auto" : "none"}
                    filter={shouldShowValue ? "none" : canHideContacts ? "none" : "blur(4px)"}
                >
                    {shouldShowValue ? (
                        children ? (
                            children
                        ) : (
                            <Text
                                whiteSpace="nowrap"
                                className={`font-poppins text_sm text_medium ${className || ""}`}
                            >
                                {value}
                            </Text>
                        )
                    ) : (
                        <Text
                            whiteSpace="nowrap"
                            className={`font-poppins text_sm text_medium ${className || ""}`}
                        >
                            {canHideContacts
                                ? applyMask(value || "", maskType)
                                : value}
                        </Text>
                    )}
                </Box>
                {!canViewAllContacts && !shouldShowValue && !canHideContacts && (
                    <Flex position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)">
                        <Flex align="center" gap={1} bg="#F2F4F7" border="1px solid #E4E7EC" borderRadius="8px" px="10px" py="3px" cursor="pointer" onClick={() => toggleReveal(rowIndex, field)}>
                            <Text fontSize="11px" fontWeight="600" color="#344054">
                                View
                            </Text>
                            <ViewIcon color="#344054" boxSize={3} />
                        </Flex>
                    </Flex>
                )
                }

            </Box>
        );
    };


    const getDisplayValue = (value: string, field: string, rowIndex: number) => {
        const isSingleFieldRevealed = revealedField.rowIndex === rowIndex && revealedField.field === field;
        const isRowRevealed = revealedRow === rowIndex;
        const shouldShowValue = canViewAllContacts || isSingleFieldRevealed || isRowRevealed;
        const maskType = maskingSettings[field] || "Hidden";
        return shouldShowValue
            ? value
            : canHideContacts
                ? applyMask(value || "", maskType)
                : value;
    };

    const NavigateLeadDetail = (lead: any) => {
        navigate(routesNames.LEADDETAIL, {
            state: {
                fullScreen: true,
                lead: {
                    leadId: lead.leadId,
                    companyName: lead.companyName,
                    pocName: lead.pocName,
                    contact: lead.contact,
                    countryCode: lead.countryCode,
                    email: lead.email,
                    assignedToUser: lead.assignedToUser,
                    leadStatus: lead.leadStatus,
                    leadStatusId: lead.leadStatusId,
                    statusReason: lead.statusReason,
                    statusReasonId: lead.statusReasonId,
                    createdBy: lead.createdBy,
                    createdAt: lead.createdAt,
                    upcomingMeetingCount: lead.upcomingMeetingCount,
                    upcomingFollowupCount: lead.upcomingFollowupCount,
                    isAccepted: lead.isAccepted,
                },
            },
        });
    };


    const NavigateLeadAssesment = (lead: any) => {
        navigate(routesNames.LEADACCEPTANCEHISTORY, {
            state: {
                leadId: lead.leadId,
            },
        });
    };


    const NavigateMyLeadEdit = (row: any) => {
        navigate(routesNames.MYLEADEDIT, {
            state: {
                leadId: row.leadId,
            },
        });
    };


    const toggleSelectAllLeads = () => {
        if (selectAllLeads) {
            setSelectedLeads([]);
        } else {
            const pendingLeadIds = leadData.leads
                .filter(
                    (lead): lead is typeof lead & { leadId: number } =>
                        lead.isAccepted === null && lead.leadId !== undefined
                )
                .map((lead) => lead.leadId);
            setSelectedLeads(pendingLeadIds);
        }
        setSelectAllLeads(!selectAllLeads);
    };


    const hasSelectableLeads = leadData.leads?.some(
        (lead) => lead.isAccepted === null
    );


    const toggleSelectLead = (leadId: number) => {
        setSelectedLeads(prev =>
            prev.includes(leadId)
                ? prev.filter(x => x !== leadId)
                : [...prev, leadId]
        );
    };

    const handleBulkAcceptLead = async () => {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        try {
            setBulkApprovalLoading(true);
            const res = await fetchApi(
                `LeadRequirement/BulkAcceptLead?timeZone=${encodeURIComponent(timezone)}`,
                "PUT",
                { leadIds: selectedLeads, reason: bulkReason }
            );
            if (res) {
                addToast({ message: res.message, status: "success" });
                setSelectedLeads([]);
                setSelectAllLeads(false);
                onBulkApprovalClose();
                loadMyLeads();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setBulkApprovalLoading(false);
        }
    };

    const handleBulkRejectLead = async () => {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        try {
            setBulkApprovalLoading(true);
            const res = await fetchApi(
                `LeadRequirement/BulkRejectLead?timeZone=${encodeURIComponent(timezone)}`,
                "PUT",
                { leadIds: selectedLeads, reason: bulkReason }
            );
            if (res) {
                addToast({ message: res.message, status: "success" });
                setSelectedLeads([]);
                setSelectAllLeads(false);
                onBulkApprovalClose();
                loadMyLeads();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setBulkApprovalLoading(false);
        }
    };


    const handleAcceptLead = async () => {
        if (!selectedLead) return;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        try {
            setApprovalLoading(true);
            const res = await fetchApi(`LeadRequirement/AcceptLead?timeZone=${encodeURIComponent(timezone)}`, "PUT", { leadId: selectedLead.leadId, reason: rejectReason, });
            if (res) {
                setSelectedLeads([]);
                setSelectAllLeads(false);
                onApprovalClose();
                setSelectedLead(null);
                setApprovalType(null);
                addToast({ message: res.message, status: "success" });
                loadMyLeads();
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setApprovalLoading(false);
        }
    };


    const handleRejectLead = async () => {
        if (!selectedLead) return;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        try {
            setApprovalLoading(true);
            const res = await fetchApi(`LeadRequirement/RejectLead?timeZone=${encodeURIComponent(timezone)}`, "PUT", {
                leadId: selectedLead.leadId,
                reason: rejectReason, // or "" if not required
            });
            if (res) {
                setSelectedLeads([]);
                setSelectAllLeads(false);
                onApprovalClose();
                setSelectedLead(null);
                setApprovalType(null);
                addToast({ message: res.message, status: "success" });
                loadMyLeads();

            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setApprovalLoading(false);
        }
    };


    return (
        <MyDiv>
            <Box>
                <Grid className="grid_container" mt={10}>
                    <GridItem colSpan={12}>

                        {selectedLeads.length > 0 && (
                            <Flex mb={4} p={3} bg="blue.50" border="1px solid" borderColor="blue.100" borderRadius="12px"
                                align={{ base: "stretch", md: "center" }} justify="space-between"
                                direction={{ base: "column", md: "row" }} gap={3}
                            >
                                <Flex align="center" gap={3}>
                                    <Box px={3} py={1} borderRadius="full" bg="blue.100" color="blue.700" fontWeight="700" fontSize="sm" >
                                        {selectedLeads.length} selected
                                    </Box>

                                    <Text fontSize="sm" color="gray.700" fontWeight="500">
                                        Choose an action for selected leads
                                    </Text>
                                </Flex>
                            </Flex>
                        )}
                        <Box mt={4} overflowX="auto" borderRadius="16px"
                            sx={{ "&::-webkit-scrollbar": { height: "2px", }, }} >



                            <CustomExpandTable autoCloseExpand={true} loading={loading} value={leadData.leads} rowKey="leadId" emptyMessage="No Leads Found"
                                getRowBgColor={(row: any) => row.isAccepted === false ? "#FFECEC" : row.isAccepted === null ? "#FFF4E5" : undefined}
                                renderExpandedContent={(row: any) => (

                                    <Box p={4}>
                                        {expandType?.leadId === row.leadId &&
                                            expandType?.type === "meeting" ? (
                                            <MeetingFormTab
                                                leadId={row.leadId}
                                                pocEmail={row.email}
                                                onMeetingSaved={onMeetingRefresh}
                                            />
                                        ) : expandType?.leadId === row.leadId &&
                                            expandType?.type === "followup" ? (
                                            <FollowUpFormTab leadId={row.leadId} onFollowUpSaved={onFollowUpRefresh} />
                                        ) : expandType?.leadId === row.leadId &&
                                            expandType?.type === "message" ? (
                                            <SendMessageForm
                                                leadId={row.leadId}
                                                pocName={row.pocName}
                                                pocEmail={row.email}
                                                onMessageSaved={onMessageRefresh}
                                            />
                                        ) : (
                                            <LeadRequirement
                                                leadId={row.leadId}
                                                leadData={row}
                                                onClose={row.closeExpand}
                                            />
                                        )}
                                    </Box>
                                )}
                            >

                                <Column header="S.No" body={(_, index) => index + 1} />
                                {/* <Column header="Lead ID" field="leadId" /> */}

                                <Column
                                    header="Company"
                                    body={(row: any, index: number) => {
                                        const blinkClass =
                                            row.isToday15MinLeft
                                                ? "blink-red"
                                                : row.isTodayMeeting
                                                    ? "blink-orange"
                                                    : "";

                                        return (
                                            <Tooltip
                                                label={getDisplayValue(row.companyName, "company", index)}
                                                hasArrow placement="top" >
                                                <Box color={
                                                    canNavigateLeadDetail
                                                        ? "#2563EB"
                                                        : "#101828"
                                                } maxW="200px" isTruncated cursor={canNavigateLeadDetail ? "pointer" : "default"}
                                                    onClick={() => {
                                                        if (canNavigateLeadDetail) {
                                                            NavigateLeadDetail(row);
                                                        }
                                                    }}>
                                                    <RevealField
                                                        rowIndex={index}
                                                        field="company"
                                                        value={row.companyName}
                                                        className={blinkClass}
                                                    />
                                                </Box>
                                            </Tooltip>
                                        );
                                    }}
                                />


                                <Column
                                    header="POC"
                                    body={(row: any, index: number) => (
                                        <Tooltip label={getDisplayValue(row.pocName, "poc", index)} hasArrow placement="top">
                                            <Box color={
                                                canNavigateLeadDetail
                                                    ? "#2563EB"
                                                    : "#101828"
                                            } maxW="180px" isTruncated cursor={canNavigateLeadDetail ? "pointer" : "default"} onClick={() => {
                                                if (canNavigateLeadDetail) {
                                                    NavigateLeadDetail(row);
                                                }
                                            }}>
                                                <RevealField rowIndex={index} field="poc" value={row.pocName} />
                                            </Box>
                                        </Tooltip>
                                    )}

                                />

                                <Column
                                    header="Contact"
                                    body={(row: any, index: number) => (
                                        <Box color={
                                            canNavigateLeadDetail
                                                ? "#2563EB"
                                                : "#101828"
                                        } cursor={canNavigateLeadDetail ? "pointer" : "default"} onClick={() => {
                                            if (canNavigateLeadDetail) {
                                                NavigateLeadDetail(row);
                                            }
                                        }} >
                                            <RevealField rowIndex={index} field="contact" value={`${row.countryCode} ${row.contact}`} />
                                        </Box>
                                    )}
                                />

                                <Column
                                    header="Email"
                                    body={(row: any, index: number) => (
                                        <Box color={
                                            canNavigateLeadDetail
                                                ? "#2563EB"
                                                : "#101828"
                                        } cursor={canNavigateLeadDetail ? "pointer" : "default"} onClick={() => {
                                            if (canNavigateLeadDetail) {
                                                NavigateLeadDetail(row);
                                            }
                                        }} >
                                            <RevealField rowIndex={index} field="email" value={row.email} />
                                        </Box>
                                    )}
                                />
                                <Column
                                    header="Website"
                                    body={(row: any, index: number) => {
                                        const canOpenWebsite =
                                            row.isAccepted ||
                                            hasPermission("LeadPool", "View Website Before Accept");

                                        return (
                                            <RevealField
                                                rowIndex={index}
                                                field="websiteUrl"
                                                value={row.websiteUrl}
                                            >
                                                {row.websiteUrl ? (
                                                    canOpenWebsite ? (
                                                        <Link
                                                            href={
                                                                row.websiteUrl.startsWith("http")
                                                                    ? row.websiteUrl
                                                                    : `https://${row.websiteUrl}`
                                                            }
                                                            isExternal
                                                            color="#2563EB"
                                                            textDecoration="underline"
                                                            maxW="180px"
                                                            display="block"
                                                            whiteSpace="nowrap"
                                                            overflow="hidden"
                                                            textOverflow="ellipsis"
                                                        >
                                                            {row.websiteUrl}
                                                        </Link>
                                                    ) : (
                                                        <Text
                                                            maxW="180px"
                                                            whiteSpace="nowrap"
                                                            overflow="hidden"
                                                            textOverflow="ellipsis"
                                                        >
                                                            {row.websiteUrl}
                                                        </Text>
                                                    )
                                                ) : (
                                                    <Text>N/A</Text>
                                                )}
                                            </RevealField>
                                        );
                                    }}
                                />
                                <Column header="Country" field="countryName" textAlign="center" />

                                <Column header="Assigned To" field="assignedToUser" />

                                <Column
                                    header="Lead Status"
                                    body={(row: any) => {
                                        const statusStyle = getStatusStyle(row.leadStatus);
                                        const isPending = row.isAccepted === null;
                                        const isAccepted = row.isAccepted === true;
                                        const isRejected = row.isAccepted === false;
                                        const isFinalStatus =
                                            row.leadStatus === "Won" ||
                                            row.leadStatus === "Lost" ||
                                            row.leadStatus === "Rejected";
                                        const canChangeLeadStatus = canUpdateStatus && isAccepted && !isFinalStatus;
                                        return (
                                            <Box display="inline-flex" alignItems="center" bg={statusStyle.bg} color={statusStyle.color} px="12px" py="6px" borderRadius="20px" fontSize="13px" fontWeight="500" gap="6px"
                                                cursor={canChangeLeadStatus ? "pointer" : "not-allowed"}
                                                opacity={canChangeLeadStatus ? 1 : 0.6}
                                                onClick={() => {
                                                    if (!canUpdateStatus) return;
                                                    if (row.isAccepted === null) {
                                                        addToast({
                                                            message: "Please accept the lead before changing its status.",
                                                            status: "warning",
                                                        });
                                                        return;
                                                    }
                                                    if (row.isAccepted === false) {
                                                        addToast({
                                                            message: "You have rejected this lead. Status cannot be changed.",
                                                            status: "error",
                                                        });
                                                        return;
                                                    }

                                                    if (!canChangeLeadStatus) return;

                                                    handleOpenStatusModal(row);
                                                }}
                                            >
                                                <Text m={0}>
                                                    {row.leadStatus || "Lead Created"}
                                                </Text>

                                                {canChangeLeadStatus && (
                                                    <Image src={ArrowIcon} boxSize="6px" />
                                                )}
                                            </Box>
                                        );
                                    }}
                                />

                                <Column
                                    header="Created At"
                                    body={(row: any) => row.createdAt ? showDateTime(row.createdAt) : "N/A"}
                                />
                                <Column header="Created By" field="createdBy" />


                                <Column
                                    header="Action"
                                    body={(row: any) => {
                                        const isPending = row.isAccepted === null;
                                        const isAccepted = row.isAccepted === true;
                                        const isRejected = row.isAccepted === false;
                                        const isBdm = row.isBdm;
                                        const isPreSales = row.isPreSales;
                                        const hasBothRoles = isBdm && isPreSales;
                                        const showAcceptedActions =
                                            hasBothRoles
                                                ? isAccepted === true
                                                : isPreSales || (isBdm && isAccepted === true);
                                        return (
                                            <Flex align="center" gap={2} wrap="nowrap" width="max-content" >

                                                {/* {isPending && isBdm && (
                                                    <>
                                                        {canAcceptLead && (
                                                            <Tooltip label="Accept Lead">
                                                                <Flex align="center" justify="center" w="28px" h="28px"
                                                                    borderRadius="full" bg="green.50" cursor="pointer"
                                                                    _hover={{ bg: "green.100" }}
                                                                    onClick={() => {
                                                                        setSelectedLead(row);
                                                                        setApprovalType("accept");
                                                                        setRejectReason("");
                                                                        onApprovalOpen();
                                                                    }}
                                                                >
                                                                    <CheckIcon color="green.500" boxSize={4} />
                                                                </Flex>
                                                            </Tooltip>
                                                        )}

                                                        {canRejectLead && (
                                                            <Tooltip label="Reject Lead">
                                                                <Flex align="center" justify="center" w="28px" h="28px"
                                                                    borderRadius="full" bg="red.50" cursor="pointer"
                                                                    _hover={{ bg: "red.100" }}
                                                                    onClick={() => {
                                                                        setSelectedLead(row);
                                                                        setApprovalType("reject");
                                                                        setRejectReason("");
                                                                        onApprovalOpen();
                                                                    }}
                                                                >
                                                                    <CloseIcon color="red.500" boxSize={3} />
                                                                </Flex>
                                                            </Tooltip>
                                                        )}
                                                    </>
                                                )} */}
                                                {row.isAccepted === null && (
                                                    <Tooltip label="Pending Lead Acceptance">
                                                        <Flex align="center" justify="center" w="24px" h="24px"
                                                            borderRadius="full" bg="orange.400" color="white"
                                                            cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                                                            _hover={canViewLeadAcceptanceHistory ? { opacity: 0.8 } : undefined}
                                                        //  onClick={() => canViewLeadAcceptanceHistory && NavigateLeadAssesment(row)}
                                                        >
                                                            <TimeIcon boxSize={3} />
                                                        </Flex>
                                                    </Tooltip>
                                                )}
                                                {showAcceptedActions && (
                                                    <>

                                                        {row.isAccepted === true && (
                                                            <Tooltip label={`Accepted: ${row.reason ? ` ${row.reason}` : ""}`}>
                                                                <Flex align="center" justify="center" w="24px" h="24px"
                                                                    borderRadius="full" bg="green.500" color="white"
                                                                    cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                                                                    _hover={canViewLeadAcceptanceHistory ? { opacity: 0.8 } : undefined}
                                                                // onClick={() => canViewLeadAcceptanceHistory && NavigateLeadAssesment(row)}
                                                                >
                                                                    <CheckIcon boxSize={3} />
                                                                </Flex>
                                                            </Tooltip>
                                                        )}
                                                        {row.isAccepted === false && (
                                                            <>
                                                                <Tooltip label={`Rejected${(row.disReason || row.disqualifyReason) ? ` [${row.disReason || row.disqualifyReason}]` : ""}${row.reason ? `: ${row.reason}` : ""}`} hasArrow>
                                                                    <Flex align="center" justify="center" w="24px" h="24px"
                                                                        borderRadius="full" bg="red.500" color="white"
                                                                        cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                                                                        _hover={canViewLeadAcceptanceHistory ? { opacity: 0.8 } : undefined}
                                                                    >
                                                                        <CloseIcon boxSize={3} />
                                                                    </Flex>
                                                                </Tooltip>
                                                                {(row.disReason || row.disqualifyReason) && (
                                                                    <Tooltip label={`Disqualify Reason: ${row.disReason || row.disqualifyReason}`} hasArrow>
                                                                        <Flex align="center" px={2.5} py={1} borderRadius="full" bg="orange.50"
                                                                            color="orange.700" border="1px solid" borderColor="orange.200" fontSize="12px"
                                                                            fontWeight="500" maxW="140px"
                                                                        >
                                                                            <Text isTruncated>{row.disReason || row.disqualifyReason}</Text>
                                                                        </Flex>
                                                                    </Tooltip>
                                                                )}
                                                            </>
                                                        )}


                                                        <Tooltip label="Meetings">
                                                            <Flex align="center" justify="center" minW="22px" h="22px" px="1" borderRadius="full" bg="#EFF8FF" color="#175CD3" fontSize="11px" fontWeight="600" cursor="pointer"

                                                            >
                                                                M {row.upcomingMeetingCount || 0}
                                                            </Flex>
                                                        </Tooltip>

                                                        <Tooltip label=" Reminders">
                                                            <Flex align="center" justify="center" minW="22px" h="22px" px="1" borderRadius="full" bg="#ECFDF3" color="#027A48" fontSize="11px" fontWeight="600" cursor="pointer"
                                                            >
                                                                R {row.upcomingFollowupCount || 0}
                                                            </Flex>
                                                        </Tooltip>
                                                        <Tooltip label=" Mail">
                                                            <Flex align="center" justify="center" minW="22px" h="22px" px="1" borderRadius="full" bg="#ECFDF3" color="#027A48" fontSize="11px" fontWeight="600" cursor="pointer"
                                                            >
                                                                M {row.mailCount || 0}
                                                            </Flex>
                                                        </Tooltip>
                                                        <Menu placement="bottom-end" >
                                                            <MenuButton as={IconButton} aria-label="Options" icon={<HamburgerIcon />} variant="ghost" size="sm" />

                                                            {row.isAccepted !== null && row.isAccepted !== false && (
                                                                <MenuList maxH="150px" overflowY="auto">
                                                                    {/* <MenuItem onClick={() => handleViewLead(row)}>
                                                        <Flex align="center" gap={2}>
                                                            <Image src={ViewIconn} boxSize="16px" />
                                                            View
                                                        </Flex>
                                                    </MenuItem> */}
                                                                    {canViewHistory && (
                                                                        <MenuItem onClick={() => handleHistoryLead(row)}>
                                                                            <Flex align="center" gap={2}>
                                                                                <Image src={HistoryIcon} boxSize="16px" />
                                                                                History
                                                                            </Flex>
                                                                        </MenuItem>
                                                                    )}
                                                                    {canViewMeetings && (<MenuItem
                                                                        onClick={() => {
                                                                            setExpandType({ leadId: row.leadId, type: "meeting", });
                                                                            row.expandRow();
                                                                        }}
                                                                    > <Flex align="center" gap={2}>
                                                                            <Image src={MeetingIcon} boxSize="16px" />
                                                                            Meeting
                                                                        </Flex>
                                                                    </MenuItem>)}



                                                                    {canViewFollowUps && (<MenuItem
                                                                        onClick={() => {
                                                                            setExpandType({ leadId: row.leadId, type: "followup", });
                                                                            row.expandRow();
                                                                        }}
                                                                    >
                                                                        <Flex align="center" gap={2}>
                                                                            <Image src={FollowupIcon} boxSize="16px" />
                                                                            Reminder
                                                                        </Flex>
                                                                    </MenuItem>)}

                                                                    {canViewMessages && (
                                                                        <MenuItem
                                                                            onClick={() => {
                                                                                setExpandType({ leadId: row.leadId, type: "message", });
                                                                                row.expandRow();
                                                                            }}
                                                                        >
                                                                            <Flex align="center" gap={2}>
                                                                                <Image src={SendMessageIcon} boxSize="16px" />
                                                                                Send Email
                                                                            </Flex>
                                                                        </MenuItem>
                                                                    )}
                                                                    {canViewLeadDetail && (
                                                                        <MenuItem onClick={() => NavigateLeadDetail(row)}>
                                                                            <Flex align="center" gap={2}>
                                                                                <ViewIcon />
                                                                                View Details
                                                                            </Flex>
                                                                        </MenuItem>
                                                                    )}
                                                                    {canViewLeadAcceptanceHistory && (
                                                                        <MenuItem onClick={() => NavigateLeadAssesment(row)}>
                                                                            <Flex align="center" gap={2}>
                                                                                <Image src={HistoryIcon} boxSize="16px" />
                                                                                Lead Acceptance History
                                                                            </Flex>
                                                                        </MenuItem>
                                                                    )}
                                                                </MenuList>)}
                                                        </Menu>

                                                    </>
                                                )}

                                                {isRejected && isBdm && (
                                                    <>
                                                        <Tooltip label={`Rejected${(row.disReason || row.disqualifyReason) ? ` [${row.disReason || row.disqualifyReason}]` : ""}${row.reason ? `: ${row.reason}` : ""}`} hasArrow>
                                                            <Flex align="center" gap={1} px={3} py={1} borderRadius="full" bg="red.50"
                                                                color="red.600" border="1px solid" borderColor="red.200" fontSize="12px"
                                                                fontWeight="600"
                                                                cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                                                                _hover={canViewLeadAcceptanceHistory ? { bg: "red.100" } : undefined}
                                                            >
                                                                <CloseIcon boxSize={2.5} />
                                                                <Text>Rejected</Text>
                                                            </Flex>
                                                        </Tooltip>
                                                        {(row.disReason || row.disqualifyReason) && (
                                                            <Tooltip label={`Disqualify Reason: ${row.disReason || row.disqualifyReason}`} hasArrow>
                                                                <Flex align="center" px={2.5} py={1} borderRadius="full" bg="orange.50"
                                                                    color="orange.700" border="1px solid" borderColor="orange.200" fontSize="12px"
                                                                    fontWeight="500" maxW="140px"
                                                                >
                                                                    <Text isTruncated>{row.disReason || row.disqualifyReason}</Text>
                                                                </Flex>
                                                            </Tooltip>
                                                        )}
                                                    </>
                                                )}

                                                {canViewNotesAndResponse && (
                                                    <Tooltip
                                                        hasArrow
                                                        placement="top"
                                                        label={
                                                            row.notesResponse?.trim()
                                                                ? "View Notes & Response"
                                                                : "Notes & Response not available"
                                                        }
                                                    >
                                                        <Flex
                                                            align="center"
                                                            justify="center"
                                                            w="24px"
                                                            h="24px"
                                                            borderRadius="full"
                                                            bg="blue.50"
                                                            color="blue.600"
                                                            cursor="pointer"
                                                            _hover={{ bg: "blue.100" }}
                                                            onClick={() => {
                                                                if (row.notesResponse?.trim()) {
                                                                    setSelectedNotesResponse(row.notesResponse);
                                                                    onNotesModalOpen();
                                                                } else {
                                                                    addToast({
                                                                        message: "Notes & Response not available",
                                                                        status: "warning",
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            <ViewIcon boxSize={4} />
                                                        </Flex>
                                                    </Tooltip>
                                                )}
                                            </Flex>
                                        )
                                    }
                                    }
                                />
                            </CustomExpandTable>

                        </Box>
                        <Modal isOpen={isApprovalOpen} onClose={onApprovalClose} isCentered >
                            <ModalOverlay />
                            <ModalContent>
                                <ModalHeader> {approvalType === "accept" ? "Accept Lead" : "Reject Lead"} </ModalHeader>
                                <ModalBody>
                                    <Text mb={3}>
                                        {approvalType === "accept"
                                            ? "Are you sure you want to accept this lead?"
                                            : "Please enter a reason for rejecting this lead."}
                                    </Text>
                                    {/* {approvalType === "reject" && ( */}
                                    <Textarea
                                        placeholder={
                                            approvalType === "accept"
                                                ? "Reason for accepting the lead (Optional)"
                                                : "Reason for rejecting the lead"
                                        }
                                        value={rejectReason}
                                        onChange={(e) => setRejectReason(e.target.value)}
                                    />

                                    {approvalType === "reject" &&
                                        rejectReason.trim().length > 0 &&
                                        rejectReason.trim().length < 20 && (
                                            <Text color="red.500" fontSize="sm" mt={1}>
                                                Reason must be at least 20 characters long.
                                            </Text>
                                        )}
                                    {/* // )} */}
                                </ModalBody>
                                <ModalFooter>
                                    <Button variant="ghost" mr={3} onClick={onApprovalClose} isDisabled={approvalLoading} >
                                        Cancel
                                    </Button>

                                    {/* <Button
                                        colorScheme={approvalType === "accept" ? "green" : "red"}
                                        onClick={() => {
                                            if (approvalType === "accept") {
                                                handleAcceptLead();
                                            } else {
                                                handleRejectLead();
                                            }
                                        }}
                                        isLoading={approvalLoading}
                                        loadingText={approvalType === "accept" ? "Accepting..." : "Rejecting..."}
                                        isDisabled={
                                            approvalLoading ||
                                            (approvalType === "reject" && !rejectReason.trim())
                                        }
                                    >
                                        {approvalType === "accept" ? "Accept" : "Reject"}
                                    </Button> */}

                                    <Button
                                        colorScheme={approvalType === "accept" ? "green" : "red"}
                                        onClick={() => {
                                            if (approvalType === "accept") {
                                                handleAcceptLead();
                                            } else {
                                                handleRejectLead();
                                            }
                                        }}
                                        isLoading={approvalLoading}
                                        loadingText={approvalType === "accept" ? "Accepting..." : "Rejecting..."}
                                        isDisabled={
                                            approvalLoading ||
                                            (approvalType === "reject" && rejectReason.trim().length < 20)
                                        }
                                    >
                                        {approvalType === "accept" ? "Accept" : "Reject"}
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </Modal>


                        <Modal isOpen={isBulkApprovalOpen} onClose={bulkApprovalLoading ? () => { } : onBulkApprovalClose} isCentered >
                            <ModalOverlay />

                            <ModalContent>
                                <ModalHeader>
                                    {bulkApprovalType === "accept" ? "Bulk Accept Leads" : "Bulk Reject Leads"}
                                </ModalHeader>

                                <ModalBody>
                                    <Text mb={3}>
                                        {bulkApprovalType === "accept"
                                            ? `Are you sure you want to accept ${selectedLeads.length} selected leads?`
                                            : `Please enter a reason for rejecting ${selectedLeads.length} selected leads.`}
                                    </Text>

                                    <Textarea
                                        placeholder={bulkApprovalType === "accept" ? "Reason (Optional)" : "Reason for rejection"
                                        }
                                        value={bulkReason}
                                        onChange={(e) => setBulkReason(e.target.value)}
                                    />

                                    {bulkApprovalType === "reject" &&
                                        bulkReason.trim().length > 0 &&
                                        bulkReason.trim().length < 20 && (
                                            <Text color="red.500" fontSize="sm" mt={1}>
                                                Reason must be at least 20 characters long.
                                            </Text>
                                        )}
                                </ModalBody>

                                <ModalFooter>
                                    <Button
                                        mr={3}
                                        onClick={onBulkApprovalClose}
                                        isDisabled={bulkApprovalLoading}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        colorScheme={bulkApprovalType === "accept" ? "green" : "red"}
                                        onClick={() =>
                                            bulkApprovalType === "accept"
                                                ? handleBulkAcceptLead()
                                                : handleBulkRejectLead()
                                        }
                                        isLoading={bulkApprovalLoading}
                                        loadingText={bulkApprovalType === "accept" ? "Accepting..." : "Rejecting..."}
                                        isDisabled={
                                            bulkApprovalLoading ||
                                            (bulkApprovalType === "reject" && bulkReason.trim().length < 20)
                                        }
                                    >
                                        {bulkApprovalType === "accept" ? "Bulk Accept" : "Bulk Reject"}
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </Modal>


                        <Modal isOpen={isNotesModalOpen} onClose={onNotesModalClose} isCentered size="xl">
                            <ModalOverlay />
                            <ModalContent borderRadius="12px">
                                <ModalHeader borderBottom="1px solid" borderColor="gray.100" py={4} pr={10}>
                                    Notes & Response
                                </ModalHeader>
                                <ModalCloseButton />
                                <ModalBody py={6}>
                                    <Box
                                        maxH="450px"
                                        overflowY="auto"
                                        pr={2}
                                        className="notes-response-content"
                                        dangerouslySetInnerHTML={{ __html: selectedNotesResponse }}
                                    />
                                </ModalBody>
                                <ModalFooter borderTop="1px solid" borderColor="gray.100" py={3}>
                                    <Button colorScheme="blue" onClick={onNotesModalClose}>
                                        Close
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </Modal>
                    </GridItem>
                </Grid>
            </Box>


        </MyDiv>
    );
};

export default CreatedLeadList;